import React from "react";
import { Link } from "react-router-dom";
import { Logo3 } from "../../../assets";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="Footer">
      <div className="footer-left">
        <div
          className="footer-logo"
          style={{
            backgroundImage: `url(${Logo3})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      </div>

      <div className="footer-right">
        <div className="footer-column">
          <h4>Platform</h4>
          <Link to="/about">About Us</Link>
          <Link to="/media">Media</Link>
          <Link to="/services">Services</Link>
          <Link to="/CoA">Certificates</Link>
          <Link to="/verification">Verification</Link>
        </div>
        <div className="footer-column">
          <h4>Links</h4>
          <Link to="/legal/terms-of-use">Terms of Use</Link>
          <Link to="/legal/buyer-guarantee">Buyer Guarantee</Link>
          <Link to="/legal/privacy-policy">Private Policy</Link>
        </div>
        <div className="footer-column">
          <h4>Join Us</h4>
          <a href="https://www.instagram.com/funoonii/">Instagram</a>
          <a href="https://x.com/funoonii123">X (Twitter)</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
